<template>
  <div class="panel-container">
    <slot />
  </div>
</template>

<script setup lang="ts">
type Props = {
  tooltip?: string
}
defineProps<Props>()
</script>

<style>
.panel-container {
  @apply w-[22rem];
  @apply relative;
  @apply flex flex-col shrink-0;
  @apply bg-body-dark;
  @apply border-r border-common-border;
}
</style>
